import { render, staticRenderFns } from "./digital-detox-a45.vue?vue&type=template&id=dbb8e5c0"
import script from "./digital-detox-a45.vue?vue&type=script&lang=js"
export * from "./digital-detox-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports